/**
 * Dispatch activity refresh event to notify Dashboard
 * Call this after any admin action (create, update, delete)
 */
export const dispatchActivityRefresh = () => {
  window.dispatchEvent(new Event('activity:refresh'));
};
